export default "__VITE_ASSET__d11dfa08__"